// @flow

import addEstimateOptional from '../../../Services/addEstimateOptional';
import type { AddEstimateOptionalParams } from '../../../types';

export default (params: AddEstimateOptionalParams) => async (dispatch: Function) => dispatch(addEstimateOptional(params))